import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { bulkUpdateProductsFunc } from "../../../store/custom-actions/products-actions/BulkUpdateProductsSlicer";
import { getProductsFunc } from "../../../store/custom-actions/products-actions/GetProductsSlicer";
import Swal from "sweetalert2";

export default function BulkUpdateModal({
  show,
  onHide,
  selectedIds,
  onSuccess,
}) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const [formData, setFormData] = useState({
    recomended: { enabled: false, value: false },
    best_selling: { enabled: false, value: false },
    active: { enabled: false, value: false },
    track_stock: { enabled: false, value: false },
  });

  const handleCheckboxChange = (field) => {
    setFormData({
      ...formData,
      [field]: {
        ...formData[field],
        enabled: !formData[field].enabled,
      },
    });
  };

  const handleValueChange = (field, value) => {
    setFormData({
      ...formData,
      [field]: {
        ...formData[field],
        value: value,
      },
    });
  };

  const handleSubmit = async () => {
    const updateData = { ids: selectedIds };

    // Add only enabled fields
    Object.keys(formData).forEach((key) => {
      if (formData[key].enabled) {
        updateData[key] = formData[key].value;
      }
    });

    // Check if at least one field is enabled
    if (Object.keys(updateData).length === 1) {
      Swal.fire({
        icon: "warning",
        title: t("Warning"),
        text: t("Please select at least one field to update"),
      });
      return;
    }

    setIsLoading(true);

    try {
      const result = await dispatch(bulkUpdateProductsFunc(updateData));

      if (bulkUpdateProductsFunc.fulfilled.match(result)) {
        Swal.fire({
          icon: "success",
          title: t("Success"),
          text: t("Products updated successfully"),
          timer: 2000,
          showConfirmButton: false,
        });

        // Refresh products list
        dispatch(getProductsFunc());

        // Reset form
        setFormData({
          recomended: { enabled: false, value: false },
          best_selling: { enabled: false, value: false },
          active: { enabled: false, value: false },
          track_stock: { enabled: false, value: false },
        });

        if (onSuccess) onSuccess();
        onHide();
      } else {
        Swal.fire({
          icon: "error",
          title: t("Error"),
          text: t("Failed to update products"),
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: t("Error"),
        text: t("An error occurred while updating products"),
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered size="md">
      <Modal.Header closeButton>
        <Modal.Title>{t("Bulk Update Products")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="alert alert-info">
          <i className="fas fa-info-circle me-2"></i>
          {t("Updating")} <strong>{selectedIds.length}</strong> {t("products")}
        </div>

        {/* Recommended */}
        <div className="mb-3 p-3 border rounded">
          <div className="form-check mb-2">
            <input
              className="form-check-input"
              type="checkbox"
              id="enable-recomended"
              checked={formData.recomended.enabled}
              onChange={() => handleCheckboxChange("recomended")}
            />
            <label
              className="form-check-label fw-bold"
              htmlFor="enable-recomended"
            >
              {t("Update Recommended Status")}
            </label>
          </div>
          {formData.recomended.enabled && (
            <div className="ms-4">
              <div className="form-check form-check-inline">
                <input
                  className="form-check-input"
                  type="radio"
                  name="recomended"
                  id="recomended-true"
                  checked={formData.recomended.value === true}
                  onChange={() => handleValueChange("recomended", true)}
                />
                <label className="form-check-label" htmlFor="recomended-true">
                  {t("Set as Recommended")}
                </label>
              </div>
              <div className="form-check form-check-inline">
                <input
                  className="form-check-input"
                  type="radio"
                  name="recomended"
                  id="recomended-false"
                  checked={formData.recomended.value === false}
                  onChange={() => handleValueChange("recomended", false)}
                />
                <label className="form-check-label" htmlFor="recomended-false">
                  {t("Remove Recommended")}
                </label>
              </div>
            </div>
          )}
        </div>

        {/* Best Selling */}
        {/* <div className="mb-3 p-3 border rounded">
          <div className="form-check mb-2">
            <input
              className="form-check-input"
              type="checkbox"
              id="enable-best_selling"
              checked={formData.best_selling.enabled}
              onChange={() => handleCheckboxChange("best_selling")}
            />
            <label
              className="form-check-label fw-bold"
              htmlFor="enable-best_selling"
            >
              {t("Update Best Selling Status")}
            </label>
          </div>
          {formData.best_selling.enabled && (
            <div className="ms-4">
              <div className="form-check form-check-inline">
                <input
                  className="form-check-input"
                  type="radio"
                  name="best_selling"
                  id="best_selling-true"
                  checked={formData.best_selling.value === true}
                  onChange={() => handleValueChange("best_selling", true)}
                />
                <label className="form-check-label" htmlFor="best_selling-true">
                  {t("Set as Best Selling")}
                </label>
              </div>
              <div className="form-check form-check-inline">
                <input
                  className="form-check-input"
                  type="radio"
                  name="best_selling"
                  id="best_selling-false"
                  checked={formData.best_selling.value === false}
                  onChange={() => handleValueChange("best_selling", false)}
                />
                <label
                  className="form-check-label"
                  htmlFor="best_selling-false"
                >
                  {t("Remove Best Selling")}
                </label>
              </div>
            </div>
          )}
        </div> */}

        {/* Active */}
        <div className="mb-3 p-3 border rounded">
          <div className="form-check mb-2">
            <input
              className="form-check-input"
              type="checkbox"
              id="enable-active"
              checked={formData.active.enabled}
              onChange={() => handleCheckboxChange("active")}
            />
            <label className="form-check-label fw-bold" htmlFor="enable-active">
              {t("Update Active Status")}
            </label>
          </div>
          {formData.active.enabled && (
            <div className="ms-4">
              <div className="form-check form-check-inline">
                <input
                  className="form-check-input"
                  type="radio"
                  name="active"
                  id="active-true"
                  checked={formData.active.value === true}
                  onChange={() => handleValueChange("active", true)}
                />
                <label className="form-check-label" htmlFor="active-true">
                  {t("Activate")}
                </label>
              </div>
              <div className="form-check form-check-inline">
                <input
                  className="form-check-input"
                  type="radio"
                  name="active"
                  id="active-false"
                  checked={formData.active.value === false}
                  onChange={() => handleValueChange("active", false)}
                />
                <label className="form-check-label" htmlFor="active-false">
                  {t("Deactivate")}
                </label>
              </div>
            </div>
          )}
        </div>

        {/* Track Stock */}
        <div className="mb-3 p-3 border rounded">
          <div className="form-check mb-2">
            <input
              className="form-check-input"
              type="checkbox"
              id="enable-track_stock"
              checked={formData.track_stock.enabled}
              onChange={() => handleCheckboxChange("track_stock")}
            />
            <label
              className="form-check-label fw-bold"
              htmlFor="enable-track_stock"
            >
              {t("Update Track Stock Status")}
            </label>
          </div>
          {formData.track_stock.enabled && (
            <div className="ms-4">
              <div className="form-check form-check-inline">
                <input
                  className="form-check-input"
                  type="radio"
                  name="track_stock"
                  id="track_stock-true"
                  checked={formData.track_stock.value === true}
                  onChange={() => handleValueChange("track_stock", true)}
                />
                <label className="form-check-label" htmlFor="track_stock-true">
                  {t("Enable Tracking")}
                </label>
              </div>
              <div className="form-check form-check-inline">
                <input
                  className="form-check-input"
                  type="radio"
                  name="track_stock"
                  id="track_stock-false"
                  checked={formData.track_stock.value === false}
                  onChange={() => handleValueChange("track_stock", false)}
                />
                <label className="form-check-label" htmlFor="track_stock-false">
                  {t("Disable Tracking")}
                </label>
              </div>
            </div>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={onHide}
          disabled={isLoading}
        >
          {t("Cancel")}
        </button>
        <button
          type="button"
          className="btn btn-primary"
          onClick={handleSubmit}
          disabled={isLoading}
        >
          {isLoading ? (
            <>
              <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              ></span>
              {t("Updating...")}
            </>
          ) : (
            <>
              <i className="fas fa-save me-2"></i>
              {t("Update Products")}
            </>
          )}
        </button>
      </Modal.Footer>
    </Modal>
  );
}
